
import AdminLogs from './logs';
import AdminUsers from './users';
import AdminSearch from './search';
import AdminPolicy from './policy';
import AdminGeoData from './geo-data';
import AdminApiKeys from './api-keys';
import AdminSettings from './settings';
import AdminResource from './resource';
import AdminDashboard from './dashboard';
import AdminUserRoles from './user-roles';
import AdminAuditTrail from './audit-trail';
import AdminLabUploads from "./lab-uploads";
import AdminLabProfiles from './lab-profiles';
import AdminConsultations from "./consultations"
import AdminResourceActions from './resource-actions';
import AdminPermissionSchema from './permission-schema';

import AdminLabReports from './lab-report';
import AdminConsultationReports from './consultation-report';
import AdminPatientsSeenReports from './patients-seen-report';

export default class LabJwtServices {
  axiosIns = null;
  jwtConfig = null;

  users = null;
  search = null;
  policy = null;
  settings = null;
  resource = null;
  userRoles = null;
  resourceActions = null;
  permissionSchema = null;

  logs = null;
  auditTrail = null;

  labReports = null;
  consultationReports = null;
  patientsSeenReports = null;

  consultations = null;
  geoData = null;
  labProfiles = null;
  labUploads = null;

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;

    this.logs = new AdminLogs(axiosIns, jwtConfig);
    this.users = new AdminUsers(axiosIns, jwtConfig);
    this.search = new AdminSearch(axiosIns, jwtConfig);
    this.policy = new AdminPolicy(axiosIns, jwtConfig);
    this.apiKeys = new AdminApiKeys(axiosIns, jwtConfig);
    this.settings = new AdminSettings(axiosIns, jwtConfig);
    this.resource = new AdminResource(axiosIns, jwtConfig);
    this.dashboard = new AdminDashboard(axiosIns, jwtConfig);
    this.userRoles = new AdminUserRoles(axiosIns, jwtConfig);
    this.auditTrail = new AdminAuditTrail(axiosIns, jwtConfig);

    this.labReports = new AdminLabReports(axiosIns, jwtConfig);
    this.consultationReports = new AdminConsultationReports(axiosIns, jwtConfig);
    this.patientsSeenReports = new AdminPatientsSeenReports(axiosIns, jwtConfig);
    
    this.geoData = new AdminGeoData(axiosIns, jwtConfig);
    this.labUploads = new AdminLabUploads(axiosIns, jwtConfig);
    this.labProfiles = new AdminLabProfiles(axiosIns, jwtConfig);
    this.consultations = new AdminConsultations(axiosIns, jwtConfig);
    this.resourceActions = new AdminResourceActions(axiosIns, jwtConfig);
    this.permissionSchema = new AdminPermissionSchema(axiosIns, jwtConfig);
  }
}
